import Big from "big.js";

export function formatTotal(
  decimalPlaces: number,
  total: Big,
  thousandsSeparator: string = ",",
) {
  let tempString = total.toFixed(decimalPlaces);
  let splitParts = tempString.split(".");
  let commafied = splitParts[0].replace(
    /(\d)(?=(\d{3})+(?!\d))/g,
    "$1" + thousandsSeparator,
  );

  // if 0 is passed in for decimal places,
  // then there is nothing to append
  if (splitParts[1]) {
    return commafied + "." + splitParts[1];
  } else {
    return commafied;
  }
}

export function formatPercent(
  decimalPlaces: number,
  total: Big,
  thousandsSeparator: string = ",",
) {
  // multiply by 100
  // then pass to formatTotal
  const percentValue = total.times(100);
  return formatTotal(decimalPlaces, percentValue, thousandsSeparator);
}
